import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import topLogo from "../../../../../assets/top/top_logo.png";
import plateImage from '../../../../../assets/IMG_8265.jpg';
import lunchtop from '../../../../../assets/lunchtop.jpg';
import tounyuamazake from '../../../../../assets/tounyuamazake.jpg';
import frenchTea from '../../../../../assets/Frenchtea.jpg';
import englandTea from '../../../../../assets/Englandtea.jpg';
import coffee from '../../../../../assets/coffee.jpg';
import sobatya from '../../../../../assets/sobatya.jpg';
import sweets from '../../../../../assets/sweets.jpg';
import { 
  container,
  innerContainer,
  menuSection, 
  mainSection,
  imageContainer,
  menuImage,
  menuImageContent,
  imageTextOverlay,
  overlayTitle,
  overlayDescription,
  contentContainer,
  menuCategories,
  categoryCard,
  categoryTitle,
  categoryTitleEn,
  menuContent,
  menuGrid,
  menuItem,
  menuItemImage,
  menuItemTitle,
  menuItemDescription,
  menuItemPrice,
  menuLogo,
  activeCard,
  foodItemWrapper,
  foodText,
  foodImage,
  foodImageContent,
  foodTitle,
  foodDescription,
  foodNote,
  foodLink,
  drinkCarouselWrapper,
  drinkItem,
  drinkImage,
  drinkTitle,
  drinkSub
} from "../menuPage.css.ts";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
// @ts-ignore
import "swiper/css";
// @ts-ignore
import "swiper/css/autoplay";
import MenuSection from "../components/MenuSection";
import MobileHeader from "../components/MobileHeader";

interface MenuItem {
  title: string;
  description: string;
  price: string;
  image: string;
  subTitle?: string;
}

interface MenuItems {
  food: MenuItem[];
  drink: MenuItem[];
  sweets: MenuItem[];
}

// 画面幅判定用フック
function useIsMobile(breakpoint = 768) {
  const [isMobile, setIsMobile] = useState(false);
  React.useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= breakpoint);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, [breakpoint]);
  return isMobile;
}

const MenuPage: React.FC = () => {
  const navigate = useNavigate();
  const [activeCategory, setActiveCategory] = useState<keyof MenuItems>('food');
  const isMobile = useIsMobile();

  const tabSections = [
    { id: 'food', label: 'お食事', en: 'FOOD' },
    { id: 'drink', label: 'ドリンク', en: 'DRINK' },
    { id: 'sweets', label: 'スイーツ', en: 'SWEETS' }
  ];


  const menuItems: MenuItems = {
    food: [
      {
        title: '酵素玄米プレート',
        description: '月替わりで変わるKitchenMüküの基本メニュー。発芽酵素玄米を主食に麹を使い無添加手造り調味料で味付けた野菜中心で肉と魚もバランス良く食べられる、ヘルシーで美味しいランチプレートです。',
        price: '¥2,500～',
        image: plateImage
      },
    ],
    drink: [
      {
        title: '玄米豆乳甘酒',
        description: '砂糖不使用でも甘味があり、米麹を使用しノンアルコールでお子様でも安心の飲む点滴・飲む美容液とも言われる玄米豆乳甘酒をご用意しております。未体験の味と遭遇してください。',
        price: '¥500',
        image: tounyuamazake,
        subTitle: 'Soy milk brown rice sweet sake',
      },
      {
        title: 'フランス紅茶',
        description: 'フルーティな香と味・発色の良さが贅沢な気分を味わえるフランス紅茶をご用意しております。',
        price: '¥800',
        image: frenchTea,
        subTitle: 'French Tea',
      },
      {
        title: 'イギリス紅茶',
        description: '本格アールグレイが楽しめるイギリス紅茶をご用意しております。',
        price: '¥500',
        image: englandTea,
        subTitle: 'England Tea',
      },
      {
        title: 'コーヒー',
        description: '専門店から仕入れた当店オリジナルブレンド豆を使用したハンドドリップコーヒーをご用意しております。',
        price: '¥500',
        image: coffee,
        subTitle: 'coffee',
      },
      {
        title: '蕎麦茶',
        description: '蕎麦の香り漂う煮出し蕎麦茶をご用意しております。',
        price: '¥500',
        image: sobatya,
        subTitle: 'Soba Tea',
      },
    
    ],
    sweets: [
      {
        title: 'Rawスイーツ',
        description: `砂糖・小麦粉・添加物不使用で甘味があり、非加熱で作られた罪悪感の少ないスイーツをお楽しみいただけます。
*Rawスイーツクリエーター<a href="https://www.instagram.com/hiloori369/" target="_blank" rel="noopener noreferrer">@hiloori369</a>`,
        price: '¥500',
        image: sweets
      },
    ]
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className={container}>
      <div className={innerContainer}>
        <MobileHeader />
        <div className={menuSection}>
          <img 
            src={topLogo} 
            alt="キッチンムク" 
            className={menuLogo} 
            onClick={() => navigate('/')}
            style={{ cursor: 'pointer' }}
          />
          <MenuSection />
        </div>
        <div className={mainSection}>
          <div className={imageContainer}>
            <div className={menuImage}>
              <img 
                src={lunchtop}
                alt="ランチ"
                className={menuImageContent}
              />
              <div className={imageTextOverlay}>
                <h1 className={overlayTitle}>ランチ</h1>
                <p className={overlayDescription}>
                月替わりの酵素玄米プレートは、発芽酵素玄米を主食に手造り無添加麹調味料で味付けた野菜中心のお菜に肉と魚もバランス良く加えた"食べて楽しい"ランチプレートです。
                </p>
              </div>
            </div>
          </div>
          <div className={contentContainer}>
            <div className={menuCategories}>
              {tabSections.map((section) => (
                <div
                  key={section.id}
                  className={`${categoryCard} ${section.id === activeCategory ? activeCard : ''}`}
                  onClick={() => setActiveCategory(section.id as keyof MenuItems)}
                >
                  <h2 className={categoryTitle}>{section.label}</h2>
                  <span className={categoryTitleEn}>{section.en}</span>
                </div>
              ))}
            </div>
            <div className={menuContent}>
              {activeCategory === 'drink' ? (
                isMobile ? (
                  <div
                    style={{
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "16px",
                      width: "100%",
                    }}
                  >
                    {menuItems.drink.map((item, idx) => (
                      <div key={idx} className={drinkItem}>
                        <img src={item.image} alt={item.title} className={drinkImage} />
                        <div className={drinkTitle}>{item.title}</div>
                        <div className={drinkSub}>{item.subTitle || ''}</div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <div className={drinkCarouselWrapper}>
                    <Swiper
                      modules={[Autoplay]}
                      spaceBetween={32}
                      slidesPerView={"auto"}
                      loop={true}
                      freeMode={true}
                      autoplay={{
                        delay: 0,
                        disableOnInteraction: false,
                      }}
                      speed={4000}
                      allowTouchMove={false}
                      style={{ width: "100%" }}
                    >
                      {menuItems.drink.map((item, idx) => (
                        <SwiperSlide
                          key={idx}
                          style={{ width: 320, display: "flex", justifyContent: "center" }}
                        >
                          <div className={drinkItem}>
                            <img src={item.image} alt={item.title} className={drinkImage} />
                            <div className={drinkTitle}>{item.title}</div>
                            <div className={drinkSub}>{item.subTitle || ''}</div>
                          </div>
                        </SwiperSlide>
                      ))}
                    </Swiper>
                  </div>
                )
              ) : ( (activeCategory === 'food' || activeCategory === 'sweets') ? (
                (menuItems[activeCategory as keyof MenuItems] as MenuItem[]).map((item, idx) => (
                  <div key={idx} className={foodItemWrapper}>
                    {isMobile ? (
                      <div className={foodText} style={{ width: "100%" }}>
                        <div className={foodTitle}>{item.title}</div>
                        <div className={foodImage}>
                          <img src={item.image} alt={item.title} className={foodImageContent} />
                        </div>
                        <div className={foodDescription} dangerouslySetInnerHTML={{ __html: item.description }} />
                        {activeCategory === 'food' && idx === 0 && (
                          <>
                            <div className={foodNote}>
                              ＊要予約（ご利用の2日前（17:00）までにお願いいたします。）<span className={foodLink} onClick={() => window.open('https://app.squareup.com/appointments/book/qgq7fvn533lm8i/LDWB4KMXMDB4D/start', '_blank')}>予約する</span>
                            </div>
                          </>
                        )}
                      </div>
                    ) : (
                      <>
                        <div className={foodText}>
                          <div className={foodTitle}>{item.title}</div>
                          <div className={foodDescription} dangerouslySetInnerHTML={{ __html: item.description }} />
                          {activeCategory === 'food' && idx === 0 && (
                            <>
                              <div className={foodNote}>
                                ＊要予約（ご利用の2日前（17:00）までにお願いいたします。）<span className={foodLink} onClick={() => window.open('https://app.squareup.com/appointments/book/qgq7fvn533lm8i/LDWB4KMXMDB4D/start', '_blank')}>予約する</span>
                              </div>
                            </>
                          )}
                        </div>
                        <div className={foodImage}>
                          <img src={item.image} alt={item.title} className={foodImageContent} />
                        </div>
                      </>
                    )}
                  </div>
                ))
              ) : (
                <div className={menuGrid}>
                  {menuItems[activeCategory as keyof MenuItems].map((item: MenuItem, index: number) => (
                    <div key={index} className={menuItem}>
                      <img src={item.image} alt={item.title} className={menuItemImage} />
                      <h4 className={menuItemTitle}>{item.title}</h4>
                      <p className={menuItemDescription}>{item.description}</p>
                      <p className={menuItemPrice}>{item.price}</p>
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MenuPage; 